import React from "react";

import { Typography } from "@mui/material";

import ContactIconHeader from "../../../../Assets/svg/menu/features/ContactIconHeader";
import CustomHeader from "../CustomHeader/CustomHeader";

const HeaderContact: React.FC = () => (
  <CustomHeader
    childLeft={
      <div
        style={{
          alignItems: "flex-start",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          style={{ fontSize: 24, fontWeight: "bold", color: "#ffffff" }}
        >
          Besoin d'aide
        </Typography>
      </div>
    }
    icon={
      <ContactIconHeader
        viewBox="100 0 80 130"
        fill="#ffffff50"
        opacity={0.5}
        style={{
          height: "138px",
          width: "425px",
        }}
      />
    }
  />
);

export default HeaderContact;
